//НЕ ИСПОЛЬЗУЕТСЯ. ИСПОЛЬЗОВАН РЕДИРЕКТ В СЕО

import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { inject, observer } from "mobx-react";
import { Link, withRouter } from "react-router-dom";
import { useQuery } from "@apollo/client";
import {
	MOBILE_TARIFFS_QUERY_2,
	MOBILE_TAGS_QUERY,
	MOBILE_OFFERED_TARIFFS,
} from "Services/queries";
import { DECLINATION_QUERY } from "Configs/queries";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import { PaddingBottom, PaddingTop } from "ComponentsUI/Spacings";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import withStyles from "react-jss";
import { Redirect404 } from "ComponentsUI/Redirects";
import Button from "ComponentsUI/Button";
import Routes from "Configs/routes";
import MobileTariffList from "ComponentsUI/MobileTariffList";
import { SimCardTags } from "Constants/Tags";
import { StubOperatorTariffs } from "ComponentsUI/Stub";
import { isMainSiteCode } from "Utils/siteConfig";

let v4 = require("uuid/v4");

const styles = (theme) => ({
	buttonSet: {
		justifyContent: "flex-start",
		marginBottom: "50px",
		"& > a": {
			margin: "5px 5px 0 0",
		},
	},
	headerSet: {
		alignItems: "center",
		marginBottom: "15px",
	},
	arrow: {
		fontSize: "24px",
		color: theme.palette.colors.purplishBlue,
	},
	header: {
		fontFamily: theme.fonts.bold,
		fontSize: "16px",
		textTransform: "uppercase",
		color: theme.palette.colors.darkSlateBlue2,
		letterSpacing: "2.2px",
		marginRight: "15px",
	},
	block: {
		display: "block",
	},
	hide: {
		display: "none",
	},
	loadMoreButton: {
		display: "flex",
		justifyContent: "center",
	},
});

const LIMIT = 15;

//НЕ ИСПОЛЬЗУЕТСЯ. ИСПОЛЬЗОВАН РЕДИРЕКТ В СЕО
const Page = (props) => {
	const [thisOfferedTariff, setThisOfferedTariff] = useState(false);
	const [queryOfferedTariff, setQueryOfferedTariff] = useState(true);

	let { classes, match } = props;
	const text = props.ApplicationModel.text;
	const siteCode = props.ApplicationModel.siteCode;

	// Закрыть модальное окно, если оно открыто во время перехода на данную страницу
	useEffect(() => {
		const modal = props.ApplicationModel.modalModel;
		if (modal.isOpen) {
			modal.toggleModal();
		}
	}, [props.match.url]);

	// Запрос на доступные теги.
	const mobileTags = useQuery(MOBILE_TAGS_QUERY, {
		variables: {
			region_url: match.params.regionUrl,
			provider_url: match.params.operator,
			tag_type: "sim",
		},
		notifyOnNetworkStatusChange: true,
	});

	// Образование фильтра для запроса о действующих тарифах у оператора по данному тегу
	const filter = [];
	if (match.params.regionUrl) {
		filter.push(`region.url=${match.params.regionUrl}`);
	}
	if (match.params.tagCode) {
		filter.push(`mobile_new.tag_sim.translit=${match.params.tagCode}`);
	}

	// Запрос в БД на тарифы оператора
	let tariffs = useQuery(MOBILE_TARIFFS_QUERY_2, {
		variables: {
			filter: filter.join("&"),
			sort: "provider.vip_b2c_priority,convergent",
			limit: LIMIT,
			offset: 0,
			providerJoin: true,
		},
		notifyOnNetworkStatusChange: true,
	});

	// Если в тарифе был запрос, но ответ пустой, то запрашиваем предложенные тарифы, если тарифы есть, то запрос
	// на недавно подключенные тарифы отменяется
	useEffect(() => {
		if (tariffs.data?.mobileTariffs?.data.length === 0) {
			setQueryOfferedTariff(false);
			setThisOfferedTariff(true);
		} else {
			setThisOfferedTariff(false);
			setQueryOfferedTariff(true);
		}
	}, [tariffs?.data]);

	// Запрос в БД на предложенные тарифы
	let offeredTariffs = useQuery(MOBILE_OFFERED_TARIFFS, {
		variables: {
			region_url: match.params.regionUrl,
			limitProvider: 1,
		},
		skip: queryOfferedTariff,
	});

	// Запрос на склонение регионов
	const regionDeclination = useQuery(DECLINATION_QUERY, {
		variables: {
			filter: `url=${match.params.regionUrl}`,
		},
		skip: queryOfferedTariff,
	});

	// Срохранение в переменную один из доступных тарифов
	let selectedTariff =
		tariffs?.data?.mobileTariffs.data.length !== 0
			? tariffs?.data?.mobileTariffs.data
			: offeredTariffs?.data?.tariffsOffered.data;

	// Вывод дополнительного списка тарифов, которые не попали на экран.
	const fetchMoreTariffs = () => {
		tariffs.fetchMore({
			variables: {
				offset: tariffs.data.mobileTariffs.data.length,
			},
			updateQuery: (prev, { fetchMoreResult }) => {
				if (!fetchMoreResult) return prev;

				return Object.assign({}, prev, {
					mobileTariffs: {
						...prev.mobileTariffs,
						data: [...prev.mobileTariffs.data, ...fetchMoreResult.mobileTariffs.data],
					},
				});
			},
		});
	};

	// Проверка на вывод экрана загрузки
	if ((tariffs.loading && (!tariffs?.data || !offeredTariffs?.data)) || mobileTags.loading) {
		return <StubOperatorTariffs />;
	}

	// Проверка, если тега в системе нет, то выводим 404.
	if (
		(match.params.tagCode === "korporativnye" && tariffs?.data?.mobileTariffs?.data.length === 0) ||
		!SimCardTags.includes(match.params.tagCode)
	) {
		return (
			<Redirect404
				message404={
					"Выбран тег korporativnye в регионе на симкарте на котором нет тарифов или выбран несуществующий тег"
				}
			/>
		);
	}

	const windowSizes = props.ApplicationModel?.windowSizeModel?.windowSizes;
	let buttonFullWidth = false;

	if (windowSizes.xs) {
		buttonFullWidth = true;
	}

	// Блок отсутствующих тарифов
	const displayText = () => (
		<div>
			{text.TARIFF_SEARCH_FAIL_1}
			<span style={{ whiteSpace: "nowrap" }}>{text.TARIFF_SEARCH_FAIL_2}</span>
			{text.TARIFF_SEARCH_FAIL_3}
		</div>
	);

	return (
		<PaddingBottom>
			<Container>
				{isMainSiteCode(siteCode) && <div></div>}
				<Row className={classes.headerSet}>
					<span className={classes.header}>теги</span>
				</Row>
				<Row className={classNames(classes.buttonSet, classes.block)}>
					<Button
						component={
							<Link
								to={generateUrl(Routes.SimKarty.route, {
									regionUrl: match.params.regionUrl,
								})}
							/>
						}
						key={v4()}
						onClick={() => {}}
						size="low"
						status={!match.params.tagCode ? "purple" : "tertiaryAccent"}
					>
						все
					</Button>
					{!!mobileTags.data.mobileTags.data &&
						mobileTags.data.mobileTags.data.map((tag) => (
							<Button
								component={
									<Link
										to={generateUrl(Routes.SimKarty.route, {
											regionUrl: match.params.regionUrl,
											tagCode: tag.translit,
										})}
									>
										{tag.name}
									</Link>
								}
								key={v4()}
								onClick={() => {}}
								size="low"
								status={match.params?.tagCode === tag.translit ? "purple" : "tertiaryAccent"}
							>
								{tag.name}
							</Button>
						))}
				</Row>
				{selectedTariff && (
					<Row>
						<MobileTariffList
							tariffs={selectedTariff}
							thisOfferedTariff={thisOfferedTariff}
							declinationsName={regionDeclination.data?.region.declinations.prepositional}
							simCards={true}
							displayText={displayText()}
							noSendMetriks={true}
							text={text}
						/>
					</Row>
				)}
				{tariffs?.data?.mobileTariffs?.data?.length <
					tariffs?.data?.mobileTariffs?.pagination?.items_total && (
					<PaddingTop>
						<div className={classes.loadMoreButton}>
							<Button
								key={v4()}
								onClick={fetchMoreTariffs}
								status="purple"
								disabled={tariffs.loading}
								fullWidth={buttonFullWidth}
							>
								Показать еще
							</Button>
						</div>
					</PaddingTop>
				)}
			</Container>
		</PaddingBottom>
	);
};

//НЕ ИСПОЛЬЗУЕТСЯ. ИСПОЛЬЗОВАН РЕДИРЕКТ В СЕО
export default withRouter(
	withDefaultParams(withStyles(styles)(inject("ApplicationModel")(observer(Page))))
);
